import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomValidator } from 'src/app/shared/customvalidator/customvalidator';
import { ApiService } from 'src/app/shared/services/api.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

  forgetPasswordForm!: FormGroup;
  errorMessages: any;
  submitted = false;
  currentPageUrl: string = '';
  backendErrorMsg: any;
  extracted_token: any;

  constructor(private formBuilder: FormBuilder,
    public apiService: ApiService,
    private toastrService: ToastrService,
    private router: Router,
    private localStorageService: LocalStorageService) { }

  ngOnInit() {
    this.errorMessages = CustomValidator.ResetErrorMessages;
    this.initializeFormBuilder();
    this.currentPageUrl = window.location.origin;
  }
  initializeFormBuilder() {
    this.forgetPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, CustomValidator.validateEmail]],
    },
      {
        validator: CustomValidator.passwordConfirmPasswordMatchValidator // Apply the custom validator
      });
  }
  get resetFormGroupControls() {
    return this.forgetPasswordForm?.controls;
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.forgetPasswordForm.invalid) {
      return;
    }

    let apiUrlPath = environment.routes.FORGOT_PASSWORD;
    let payload = {
      "email": this.forgetPasswordForm.get('email')?.value,
      "url": `${this.currentPageUrl}/resetPassword` // attach entire URL with '/resetPassword'  
    }

    return this.apiService.post(apiUrlPath, payload).subscribe(response => {

      if (response?.status == 200) {
        //success response
        let callbackUrl = response?.url;
        if (callbackUrl) {
          const segments = callbackUrl.split('/');
          this.extracted_token = segments.pop() || null;
        }
        
        this.localStorageService.setItem('forgetPwdToken', this.extracted_token);
        this.forgetPasswordForm.reset();
        this.submitted = false;
        // this.router.navigate(['/resetPassword']);
        //for success notification
        this.toastrService.success('A reset password link has been sent to your registered email. Reset link is valid for next 30 minutes.');
      } else {
        this.backendErrorMsg = response['message'];
        // this.toastrService.error(response.message, '', { progressBar: true, progressAnimation: 'increasing' });
      }
    }, error => {
      // this.toastrService.error(error.data.message, '', { progressBar: true, progressAnimation: 'increasing' });
    });

  }
}
